module.exports = __webpack_public_path__ + "static/media/indvstry-webapp-mobile.f4d6739a.mp4";